import React from 'react'
import { EventGQL } from '../../Api'
import { CardSwiper } from '../../Components/CardSwiper'
import { PLL_IMAGES } from '../../Config/config'
import { isChampSeriesLive } from '../../Config/League/league.config'
import { mapEventWeeks } from '../../Utils'
import { WeekItem } from './WeekItem'

type SliderParams = {
  eventsList: EventGQL[]
  weeks: string[]
  currentWeek: string
  page: string
  idx?: string
  direction?: 'vertical' | 'horizontal'
  handleWeekChange: (week: string) => void
}

export const WeekSlider: React.FC<React.PropsWithChildren<SliderParams>> = ({
  eventsList,
  weeks,
  currentWeek,
  idx,
  page,
  direction = 'horizontal',
  handleWeekChange,
}) => {

  const checkActiveWeek = (wk: string) => {
    return currentWeek === wk ? true : false
  }
  const getImageObj = (wk: string) => {
    if(isChampSeriesLive && wk === '0'){ //Champ Series Week
      return {
        webp: PLL_IMAGES.champSeriesLogo.webp,
        fallback: PLL_IMAGES.champSeriesLogo.fallback
      }
    }
    return null
  }

  return (
    <>
      {eventsList && (
        <CardSwiper
          items={weeks.map((wk) => (
            <WeekItem
              weekEvents={mapEventWeeks({ week: wk, events: eventsList })}
              week={wk}
              selected={checkActiveWeek(wk)}
              page={page}
              onSelectChange={handleWeekChange}
              direction={direction}
              imgObj={getImageObj(wk)}
            />
          ))}
          idx={idx}
          cardSize='weekendItem'
          noMargin
          showScrollbar={window.innerWidth <= 760 ? false : true}
          direction={direction}
        />
      )}
    </>
  )
}
